export default {
  common: {
    advertising: {
      title: 'Suggestion',
      button: {
        viewDetails: 'View Details',
      },
    },
    verifyPhone: {
      title: 'Verify Phone',
      form: {
        phone: {
          label: 'phone',
          placeholder: 'please input phone',
          rules: {
            required: 'please input phone',
            incomplete: 'Please enter complete country code and phone number',
            format: 'Phone number must be in 7-15 digits including country code',
          },
        },
        phoneCode: {
          label: 'verifyCode',
          placeholder: 'please input verifyCode',
          rules: {
            required: 'please input verifyCode',
            length: 'Verification code must be 6 digits',
          },
        },
        button: {
          submitText: 'submit',
          sendVerificationCode: 'sendVerificationCode',
          cancelText: 'Skip',
        },
      },
    },
    goDeposit: {
      title: 'Account Opening',
      message:
        'After the first deposit is successful, MT real account will be automatically created.',
      button: {
        confirm: 'Go Deposit',
        cancel: 'Cancel',
      },
    },
    kycModal: {
      title: 'Profile Incomplete',
      description: 'Please complete your profile verification to unlock this feature.',
      confirm: 'Complete Now',
      cancel: 'Later',
    },
    noAccountTradingModal: {
      title: 'Trading Unavailable',
      description: 'Please open an account before accessing the trading page.',
      confirm: 'Open Account',
      cancel: 'Later',
    },
    verifyTips: {
      title: 'Security Reminder',
      description: 'To keep your account secure, please complete identity verification in time.',
      subDescription: 'Identity verification enhances account protection and prevents asset risks.',
      confirm: 'Verify Now',
      cancel: 'Later',
    },
  },
  settings: {
    editNickName: {
      title: 'Edit Nickname',
      form: {
        nickName: {
          label: 'Nickname',
          placeholder: 'Please enter your nickname',
        },
        confirm: 'Confirm',
        cancel: 'Cancel',
      },
    },
    editBiography: {
      title: 'Edit Biography',
      form: {
        biography: {
          label: 'Biography',
          placeholder: 'Please enter your biography',
        },
        confirm: 'Confirm',
        cancel: 'Cancel',
      },
    },
    updateAvatar: {
      title: 'Update Avatar',
      form: {
        avatar: {
          label: 'Avatar',
          placeholder: 'Please select an avatar',
        },
        confirm: 'Confirm',
        cancel: 'Cancel',
        message: {
          error: 'Please select an avatar',
        },
      },
    },
    updatePhoneModal: {
      title: 'Update Phone',
      form: {
        phone: {
          label: 'Phone',
          placeholder: 'Please enter your phone',
          message: {
            required: 'Please enter your phone',
          },
        },
        phoneCode: {
          label: 'Phone Verification Code',
          placeholder: 'Please enter verification code',
          sendCode: 'Send Code',
        },
        phone_code: {
          message: {
            required: 'Please enter verification code',
            length: 'Verification code must be 6 digits',
          },
        },
        confirm: 'Confirm',
        cancel: 'Cancel',
      },
    },
    updateLoginPassword: {
      title: 'Update Login Password',
      form: {
        newPassword: {
          label: 'New Password',
          placeholder: 'Please enter your new password',
          message: {
            required: 'Please enter your new password',
          },
        },
        confirm: 'Confirm',
        cancel: 'Cancel',
      },
    },
    updateFundPassword: {
      title: 'Update Fund Password',
      form: {
        newPassword: {
          label: 'New Password',
          placeholder: 'Please enter your new password',
          message: {
            length: 'Password must be 6 digits',
          },
        },
        confirm: 'Confirm',
        cancel: 'Cancel',
        message: {
          required: 'Please enter your new password',
        },
      },
    },
    updatePassKeyName: {
      title: 'Update Name',
      form: {
        name: {
          label: 'Passkey Name',
          placeholder: 'Please enter your passkey name',
        },
      },
      message: {
        required: 'Please enter your passkey name',
      },
    },
    addCryptoModal: {
      title: 'Add Crypto Wallet',
      description:
        'To ensure the security of your assets, after adding or modifying the withdrawal account, withdrawal and external transfer will be disabled for ',
      timeLimit: '{time} seconds',
      form: {
        type: {
          label: 'Crypto Wallet',
          placeholder: 'Please select',
          required: 'Please select a crypto wallet',
        },
        address: {
          label: 'Wallet Address',
          placeholder: 'Please enter your wallet address',
          required: 'Please enter your wallet address',
        },
        message: {
          error: 'Please select a crypto wallet',
        },
        confirm: 'Confirm',
        cancel: 'Cancel',
      },
    },
    addBankModal: {
      title: 'Add Bank Account',
      description:
        'To ensure the security of your assets, after adding or modifying the withdrawal account, withdrawal and external transfer will be disabled for ',
      timeLimit: '{time} seconds',
      form: {
        username: {
          label: 'Cardholder Name',
          placeholder: 'Please enter your cardholder name',
          required: 'Please enter your cardholder name',
        },
        bank_name: {
          label: 'Bank Name',
          placeholder: 'Please enter your bank name',
          required: 'Please enter your bank name',
        },
        bank_card_no: {
          label: 'Bank Card No',
          placeholder: 'Please enter your bank card no',
          required: 'Please enter your bank card no',
        },
        ifsc: {
          label: 'Swift Code',
          placeholder: 'Please enter your swift code',
          required: 'Please enter your swift code',
        },
        isAgree: {
          label: 'I have read and agree to',
          required: 'must agree to',
          description: 'You are adding a new bank card, you need to agree to',
          link: 'Credit/Debit Card Terms.',
        },
        confirm: 'Confirm',
        cancel: 'Cancel',
      },
    },
    addWireBankModal: {
      title: 'Add Wire Bank Account',
      description:
        'To ensure the security of your assets, after adding or modifying the withdrawal account, withdrawal and external transfer will be disabled for ',
      timeLimit: '{time} seconds',
      form: {
        wire_username: {
          label: 'Cardholder Name',
          placeholder: 'Please enter your cardholder name',
          required: 'Please enter your cardholder name',
        },
        wire_address: {
          label: 'Address',
          placeholder: 'Please enter your address',
          required: 'Please enter your address',
        },
        wire_bankname: {
          label: 'Bank Name',
          placeholder: 'Please enter your bank name',
          required: 'Please enter your bank name',
        },
        wire_bankaccount: {
          label: 'Bank Card No',
          placeholder: 'Please enter your bank card no',
          required: 'Please enter your bank card no',
        },
        wire_swifcode: {
          label: 'Swift Code',
          placeholder: 'Please enter your swift code',
          required: 'Please enter your swift code',
        },
        wire_remark: {
          label: 'Remark',
          placeholder: 'Please enter your remark',
          required: 'Please enter your remark',
        },
        isAgree: {
          label: 'I have read and agree to',
          required: 'must agree to',
          description: 'You are adding a new bank card, you need to agree to',
          link: 'Credit/Debit Card Terms.',
        },
        confirm: 'Confirm',
        cancel: 'Cancel',
      },
    },
    deleteModal: {
      title: 'Delete Account',
      message: 'Are you sure you want to delete this account?',
      form: {
        confirm: 'Confirm',
        cancel: 'Cancel',
      },
    },
  },
  account: {
    common: {
      confirmText: 'Confirm',
      cancelText: 'Cancel',
    },
    createAccount: {
      form: {
        internal: {
          tip: {
            cannotCreateReal: 'You need to complete the first deposit to create a real account',
          },
        },
      },
    },
    leverage: {
      error: {
        sameLeverage: 'Leverage cannot be the same',
      },
    },
  },
}
